import './accountAuthorizationStyles.css';
export const commonStyles = "c1t2segl";
export const ltrStyles = "l5dd3k5";
export const rtlStyles = "r1n1bal1";